export const environment = {
    production: false,
    baseUrl: 'https://api.cobro-servicios.test.procesa.com.py/v1/',
    appId: 'py.com.procesa.test.sistema',
    loginUrl: 'https://sistema.test.procesa.com.py',
    urlValidacionToken: 'https://api.web.test.procesa.com.py/v1/'
  };
